import type { StaticEntityType } from "@/config";
import { EmbeddedPreview, usePdfDetails } from "@library/components";
import type { EmbeddedProps } from "../types";

export const Preview = ({ entity }: { entity: StaticEntityType }) => {
  const { settings } = entity as StaticEntityType<EmbeddedProps>;
  const { active } = settings;
  const { shortUrl } = usePdfDetails();
  let {
    metaImage = "",
    metaDescription = "",
    metaTitle = "",
    metaIcon = "",
    metaSiteName = "",
    metaDomain = "",
    link = "",
  } = settings;

  let src = link as string;
  if (!metaTitle) metaTitle = link;
  if (!metaIcon)
    metaIcon = "https://www.storydoc.com/assets/images/companies/link.svg";
  if (!metaImage) metaImage = metaIcon;

  if (active === "code") {
    const codeIcon =
      "https://www.storydoc.com/assets/images/companies/code.svg";
    metaTitle = settings.metaTitle || "HTML Element";
    metaDescription = settings.metaDescription || "Custom HTML Element";
    metaDomain = settings.metaDomain || "Code";
    metaIcon = settings.metaIcon || codeIcon;
    metaImage = settings.metaImage || metaIcon;
    if (shortUrl) src = shortUrl;
  } else {
    if (src && src.startsWith("https://")) {
      const url = new URL(src as string);
      if (!metaDomain) metaDomain = url.hostname;
    }
  }

  return (
    <EmbeddedPreview
      payload={{
        metaTitle,
        metaDescription,
        metaIcon,
        metaSiteName,
        metaDomain,
        metaImage,
        src,
      }}
      isVisible={true}
    />
  );
};
